<script>
import Icon from "@/components/atoms/icon";
import {
  passwordLength,
  passwordUpper,
  passwordLower,
  passwordNumber
} from "@/utils/form-validators";

export default {
  name: "InscriptionFormPasswordRequirements",
  components: {
    Icon
  },
  props: {
    password: {
      type: String,
      required: true
    }
  },
  computed: {
    requirementNbCaracteres() {
      return passwordLength(this.password);
    },
    requirementChiffre() {
      return passwordNumber(this.password);
    },
    requirementMajuscule() {
      return passwordUpper(this.password);
    },
    requirementMinuscule() {
      return passwordLower(this.password);
    }
  }
};
</script>

<template>
  <div class="c-modifier-mdp-form__requirements">
    <div class="c-modifier-mdp-form__requirement">
      <Icon
        :name="requirementNbCaracteres ? 'check' : 'cross'"
        :variant="requirementNbCaracteres ? 'success' : 'alert'"
        size="xs"
      /> 8 caractères
    </div>
    <div class="c-modifier-mdp-form__requirement">
      <Icon
        :name="requirementChiffre ? 'check' : 'cross'"
        :variant="requirementChiffre ? 'success' : 'alert'"
        size="xs"
      /> 1 chiffre
    </div>
    <div class="c-modifier-mdp-form__requirement">
      <Icon
        :name="requirementMajuscule ? 'check' : 'cross'"
        :variant="requirementMajuscule ? 'success' : 'alert'"
        size="xs"
      /> 1 majuscule
    </div>
    <div class="c-modifier-mdp-form__requirement">
      <Icon
        :name="requirementMinuscule ? 'check' : 'cross'"
        :variant="requirementMinuscule ? 'success' : 'alert'"
        size="xs"
      /> 1 minuscule
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/modifier-mdp-form.scss";
</style>
